import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';

interface TableComponentProps<T> {
    headers: string[];
    data: T[];
    error?: string | null;
    loading?: boolean;
    renderRow: (item: T, index: number) => JSX.Element;
}

const TableComponent = <T,>({
    headers,
    data,
    renderRow,
}: TableComponentProps<T>) => (
    <TableContainer
        component={Paper}
        className="mt-6 shadow-lg rounded-lg"
        sx={{
            maxHeight: '485px', // Set the maximum height of the table container
            overflowY: 'auto', // Enable vertical scrolling
            display: 'block', // Ensure the container is a block-level element
            position: 'relative', // Ensure proper positioning for the sticky header
            scrollbarWidth: 'thin', // For Firefox
            '&::-webkit-scrollbar': {
                width: '8px', // Set the width of the scrollbar
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888', // Color of the scrollbar thumb
                borderRadius: '8px', // Rounded edges for the scrollbar thumb
            },
            '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555', // Hover color for the scrollbar thumb
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: '#f1f1f1', // Background of the scrollbar track
            },
        }}
    >
        <Table className="min-w-full table-auto">
            <TableHead
                sx={{
                    position: 'sticky', // Make the header sticky
                    top: 0, // Keep the header at the top
                    zIndex: 1, // Ensure the header stays above the table body
                    backgroundColor: '#1a1a1a', // Set background color for the header
                }}
            >
                <TableRow>
                    {headers.map((header) => (
                        <TableCell
                            key={header}
                            sx={{
                                color: '#FFFFFF',
                                fontFamily: 'Jost, sans-serif',
                                fontWeight: 'bold',
                                padding: '12px', // Padding for header consistency
                                textAlign: 'left', // Align content to the left
                            }}
                        >
                            {header}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody
                sx={{
                    height: 'auto', // Ensure the body height can grow
                }}
            >
                {data.length > 0 ? (
                    data.map((item, index) => renderRow(item, index))
                ) : (
                    <TableRow>
                        <TableCell
                            colSpan={headers.length}
                            align="center"
                            className="text-center py-4 font-jost"
                            sx={{
                                fontFamily: 'Jost, sans-serif',
                                padding: '16px',
                            }}
                        >
                            No data available
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    </TableContainer>
);

export default TableComponent;
